<button *ngIf="isBtn" class="btn btn-outline-primary" (click)="openModalPNR(PNRmodal)">
  {{ 'EXPORT_TO_PNR.EXPORT.LABEL' | translate }}
</button>
<ul *ngIf="!isBtn" class="mb-0" (click)="openModalPNR(PNRmodal); popover.close()">
  <li *ngIf="!isBtn">
    {{ 'EXPORT_TO_PNR.MENU.LABEL' | translate }}
  </li>
</ul>

<ng-template #PNRmodal let-c="close" let-d="dismiss">
  <div class='pnr-modal-body'>
    <textarea class="text-area-mask" [(ngModel)]="PNR"></textarea>
    <div class="modal-bottom">
      <button class="btn btn-secondary" (click)="clearPNR(); d('closed')">
        {{ 'EXPORT_TO_PNR.MODAL.CLOSE_BUTTON' | translate }}
      </button>
      <button class="btn btn-primary" [cdkCopyToClipboard]="PNR" (click)="clearPNR(); c('ok')">
        {{ 'EXPORT_TO_PNR.MODAL.COPY_BUTTON' | translate }}
      </button>
    </div>
  </div>
</ng-template>
